export default __webpack_public_path__ + "static/media/noStudents.17f219ee.svg";